export default __webpack_public_path__ + "static/media/eval-image.36e451d6.png";